import { render, staticRenderFns } from "./ViewSeed.vue?vue&type=template&id=b586d2fa&scoped=true&"
import script from "./ViewSeed.vue?vue&type=script&lang=js&"
export * from "./ViewSeed.vue?vue&type=script&lang=js&"
import style0 from "./ViewSeed.vue?vue&type=style&index=0&id=b586d2fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b586d2fa",
  null
  
)

export default component.exports